import { ReactComponent as NonCategorized } from './non-categorized.svg';
import { ReactComponent as SettingConfig } from './setting-config.svg';
import { ReactComponent as DocumentIcon } from './document.svg';
import { ReactComponent as FilterIcon } from './filter.svg';
import { ReactComponent as CircleMinus } from './circle-minus.svg';
import { ReactComponent as Forward } from './forward.svg';
import { ReactComponent as Link } from './link.svg';
import { ReactComponent as Cohort } from './cohort.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as Bell } from './bell.svg';
import { ReactComponent as ChatStopIcon } from './chat-stop.svg';
import { ReactComponent as ReAskIcon } from './re-ask.svg';
import { ReactComponent as CohortChat } from './chat.svg';
import { ReactComponent as QuestionMark } from './blue-question-mark.svg';
import { ReactComponent as StepCheckIcon } from './step-check-icon.svg';
import { ReactComponent as FileIcon } from './file.svg';
import { ReactComponent as ThumbsUp } from './thumbs-up.svg';
import { ReactComponent as ThumbsDown } from './thumbs-down.svg';
import { ReactComponent as ThumbsUpFilled } from './filled-thumbs-up.svg';
import { ReactComponent as ThumbsDownFilled } from './filled-thumbs-down.svg';
import { ReactComponent as UseFilter } from './use-filter.svg';
import { ReactComponent as DoNotUseFilter } from './do-not-use-filter.svg';

export const icons = {
    NonCategorized,
    SettingConfig,
    DocumentIcon,
    FilterIcon,
    CircleMinus,
    Forward,
    Link,
    Cohort,
    CohortChat,
    Edit,
    Bell,
    QuestionMark,
    StepCheckIcon,
    FileIcon,
    ChatStopIcon,
    ReAskIcon,
    ThumbsUp,
    ThumbsDown,
    ThumbsUpFilled,
    ThumbsDownFilled,
    UseFilter,
    DoNotUseFilter,
};
